<template>
  <v-container fluid>
    <v-container>
      <h1 class="text-h3">404 - {{ $t("notFound") }}</h1>
    </v-container>
  </v-container>
</template>

<script>
export default {
  name: "NotFound",
};
</script>
